/******************
 字符串处理相关工具
******************/
export default {
  intTo2Str: function (val) {
    if (val < 10) {
      val = '0' + val
    }
    return val
  }
}



// WEBPACK FOOTER //
// ./src/common/strUtils.js